// (function() {
//   'use strict';

//   angular
//       .module('invoice.services')
//       .factory('InvoicePayments', InvoicePayments);

//   InvoicePayments.$inject = ['$http'];

//   function InvoicePayments($http) {
//       return{
//           list: list,
//           destroy: destroy,
//           create: create,
//           partial_update: partial_update,
//           update: update,
//           total: total,
//           retrieveInvoice: retrieveInvoice
//       };

//       function list(params) {
//           var url = Urls['invoicepayment-list']();
//           return $http({
//               url: url,
//               method: 'GET',
//               params: params,
//               paramSerializer: '$httpParamSerializerJQLike'
//           }).then(function(response){
//               angular.forEach(response.data, function(item){
//                   item.amount = parseFloat(item.amount);
//               });
//              return response;
//           })
//       }

//       function destroy(invoice_payment_id) {
//           var url = Urls['invoicepayment-detail'](invoice_payment_id);
//           return $http.delete(url);
//       }

//       function create(invoice_payment) {
//           invoice_payment.amount = parseFloat(invoice_payment.amount).toFixed(2).toString();
//           var url = Urls['invoicepayment-list']();
//           return $http.post(url, invoice_payment);
//       }
      
//       function update(id, data) {
//           var url = Urls['invoicepayment-detail'](id);
//           return $http.put(url, data);
//       }

//       function partial_update(invoice_payment) {
//           var url = Urls['invoicepayment-detail'](invoice_payment.id);
//           return $http.patch(url, invoice_payment);
//       }

//       function total(params) {
//           var url = Urls['invoicepayment-total']();
//           return $http({
//               url: url,
//               method: 'GET',
//               params: params,
//               paramSerializer: '$httpParamSerializerJQLike'
//           })
//       }

//       function retrieveInvoice(pk){
//           var url = Urls['invoicepayment-invoice'](pk);
//           return $http.get(url);
//       }
//   }

// })();

import customAxios from "./axiosConfig";

const InvoicePaymentsService = {
  list (params) {
    const api_url = window.Urls['invoicepayment-list']();
    return customAxios.get(api_url, { params: params });
  },
  create (invoice_payment) {
    invoice_payment.amount = parseFloat(invoice_payment.amount).toFixed(2).toString();
    const api_url = window.Urls['invoicepayment-list']();
    return customAxios.post(api_url, invoice_payment);
  },
  partial_update (invoice_payment) {
    const api_url = window.Urls['invoicepayment-detail'](invoice_payment.id);
    return customAxios.patch(api_url, invoice_payment);
  },
  destroy (invoice_payment_id) {
    const api_url = window.Urls['invoicepayment-detail'](invoice_payment_id);
    return customAxios.delete(api_url);
  },
  retrieveInvoice (invoice_id) {
    const api_url = window.Urls['invoicepayment-invoice'](invoice_id);
    return customAxios.get(api_url);
  }
}

export default InvoicePaymentsService;
